"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var firestore_1 = require("firebase/firestore");
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var constants_1 = require("./constants");
var PerPlanOnchargeSettings_1 = __importDefault(require("./PerPlanOnchargeSettings"));
var DISCOUNT_MODE_OPTIONS = (0, general_1.makeValueLabelArray)(interfaces_1.DISCOUNT_MODES, constants_1.DISCOUNT_MODES_MAP);
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var OnchargeSettings = function (_a) {
    var rechargedCompanyVendor = _a.rechargedCompanyVendor;
    var _b = __read((0, hooks_1.useSubmitter)('recharged_company_vendors', rechargedCompanyVendor === null || rechargedCompanyVendor === void 0 ? void 0 : rechargedCompanyVendor.id), 2), updateRechCompVendor = _b[0], isUpdatingRechCompVendor = _b[1];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { value: (rechargedCompanyVendor === null || rechargedCompanyVendor === void 0 ? void 0 : rechargedCompanyVendor.discountMode)
                        ? { value: rechargedCompanyVendor.discountMode, label: constants_1.DISCOUNT_MODES_MAP[rechargedCompanyVendor.discountMode] }
                        : null, onChange: function (option) { var _a; return updateRechCompVendor({ discountMode: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : (0, firestore_1.deleteField)() }); }, disabled: isUpdatingRechCompVendor, options: DISCOUNT_MODE_OPTIONS }) }), (rechargedCompanyVendor === null || rechargedCompanyVendor === void 0 ? void 0 : rechargedCompanyVendor.discountMode) === 'per_plan' && ((0, jsx_runtime_1.jsx)(PerPlanOnchargeSettings_1.default, { rechargedCompanyVendor: rechargedCompanyVendor }))] }));
};
exports.default = OnchargeSettings;
